import { graphql } from 'gatsby';
import React from 'react';

// This block is not being used and will be removed.

const ReviewGrid: React.FC<Queries.ReviewGridDataFragment> = () => null;

export const query = graphql`
  fragment ReviewGridData on CsReviewGrid {
    ... on CsReviewGrid {
      settings {
        hasWidget
      }
      reviews {
        customer {
          fullName
          byline
          quote
          rating
        }
      }
    }
  }
`;

export default ReviewGrid;
